var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3535,
    cy: 27.606,
    r: 26.9316,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5102 26.476C27.4102 26.466 27.2902 26.466 27.1802 26.476C24.8002 26.396 22.9102 24.446 22.9102 22.046C22.9102 19.596 24.8902 17.606 27.3502 17.606C29.8002 17.606 31.7902 19.596 31.7902 22.046C31.7802 24.446 29.8902 26.396 27.5102 26.476Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5103 30.166C20.0903 31.786 20.0903 34.426 22.5103 36.036C25.2603 37.876 29.7703 37.876 32.5203 36.036C34.9403 34.416 34.9403 31.776 32.5203 30.166C29.7803 28.336 25.2703 28.336 22.5103 30.166Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/userImg.c9e31cede40778099615ecf540260cfa.svg";
export { ForwardRef as ReactComponent };